export default {
      id: "color_bacteria-usage",
      viewBox: "0 0 302 360",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria",
      toString: function () {
        return this.url;
      }
    }